import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { Divider } from 'web-ui-components/lib/atoms/layout';
import { TogglePanel } from 'web-ui-components/lib/molecules/panels';
import { ToggleOption } from 'web-ui-components/lib/molecules/toggle';
import { Icon } from 'web-ui-components/lib/atoms/iconography';

const displayIcon = (iconType) => (
  <Icon iconType={iconType} className="c-a-button__icon" direction="right" />
);
const toggleListOptionFactory = (toggleList, handleOnChange) =>
  map(toggleList, (item, index) => (
    <div>
      <ToggleOption
        icon={displayIcon(item.getIconType())}
        title={item.getTitle()}
        blurb={item.getText()}
        active={item.isEnabled()}
        onChange={() => {
          handleOnChange(item.id, !item.isEnabled());
        }}
      />{' '}
      {!(index === toggleList.length - 1) && (
        <Divider className="u-margin-bottom-1 u-margin-top-1" />
      )}
    </div>
  ));
const handleMethodToggleCall = (showTransactionMethods, toggleTransactionMethod) => {
  toggleTransactionMethod(!showTransactionMethods);
};
const setMethodToggleText = (isTransactionMethodsEnabled, content) => {
  return isTransactionMethodsEnabled
    ? content.transactionAmountText
    : content.transactionMethodToggleText;
};
const toggleOptionFactory = (isTransactionMethodsEnabled, toggleTransactionMethod, content) => (
  <div>
    <ToggleOption
      icon={displayIcon('TransactionMethodOutlineLarge')}
      title={content.transactionMethodTitle}
      active={isTransactionMethodsEnabled}
      blurb={setMethodToggleText(isTransactionMethodsEnabled, content)}
      onChange={() => {
        handleMethodToggleCall(isTransactionMethodsEnabled, toggleTransactionMethod);
      }}
    />{' '}
    {isTransactionMethodsEnabled && <Divider className="u-margin-bottom-1 u-margin-top-1" />}
  </div>
);
const TransactionMethodComponent = ({
  toggleList,
  content,
  handleTransactionMethodChange,
  showTransactionMethods,
  toggleTransactionMethod,
}) => (
  <Card bordered="unbranded" className="u-component-spacing">
    <TogglePanel
      toggleOptionFactory={() =>
        toggleOptionFactory(showTransactionMethods, toggleTransactionMethod, content)
      }
      active={showTransactionMethods}
    >
      {toggleListOptionFactory(toggleList, handleTransactionMethodChange)}
    </TogglePanel>
  </Card>
);

TransactionMethodComponent.propTypes = {
  toggleList: PropTypes.array,
  content: PropTypes.shape({}),
  handleTransactionMethodChange: PropTypes.func,
  showTransactionMethods: PropTypes.bool,
  toggleTransactionMethod: PropTypes.func,
};

export default TransactionMethodComponent;
